import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import {
  fetchPracticeReminderSettings,
  fetchPracticeReminderCardInfo
} from '@actions/practiceSession';
import { getIsReminderSettingsAvailable } from '@selectors/practiceSession';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const useReminderFetch = ({ validateStaleData = false } = {}) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const { goalUID } = router.query;

  const isReminderSettingsAvailable = useSelectorWithShallowEqual(
    getIsReminderSettingsAvailable(goalUID)
  );

  useEffect(() => {
    if (!isReminderSettingsAvailable) {
      dispatch(fetchPracticeReminderSettings(goalUID));
      dispatch(fetchPracticeReminderCardInfo(goalUID));
    } else if (validateStaleData) {
      dispatch(fetchPracticeReminderCardInfo(goalUID));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goalUID]);

  return {
    isReminderSettingsAvailable
  };
};

export default useReminderFetch;
